// Note: you can override theme from shared by passing field with the same name
// (e.g. secondary: '#e95160',). This object is merged OVER shared/theme in
// pages/ThemeProvider.jsx ({ ...themeComp, ...themeApp }).
export default {
  mainBackgroundColor: '#F7FAFD',
  greenBackgroundColor: '#7AC943',
  yellowBackgroundColor: '#EAC600',

  // --- Redesign 2026-06: errorColor (#d92b3c) lebt jetzt als Single-Source in
  // shared/styles/theme.js (vorher hier als Override). Hier bewusst ENTFERNT, damit
  // es nur EINE Quelle gibt; der shared-Wert greift weiterhin via ThemeProvider-Merge.

  // --- Redesign 2026-06 (Button modernization): muted success/approve green for the
  // APPROVE button color, replacing the hardcoded CSS keyword `green` (= #008000, a
  // garish theme-foreign green). Used by Button/ButtonStyled.js.
  approveColor: '#2e9e5b',

  // --- Redesign 2026-06: role colors (header role badge). Centralized here so
  // they stop being hardcoded/duplicated. Muted, brand-adjacent and explicitly
  // NOT coral/red (which doubles as CTA + error + alert bell).
  roleApplicant: '#0e9f8e', // Schüler – Teal
  roleApplicantBg: '#e2f4f1',
  roleTeacher: '#2d5ba8', // Lehrer – Indigo
  roleTeacherBg: '#e5ebf5',
  roleCompany: '#d98324', // Betrieb – Amber
  roleCompanyBg: '#faeede',
  roleProvider: '#7a5bc2', // Bildungsbegleiter – Violet
  roleProviderBg: '#eee9f7',

  // --- Redesign 2026-06: Radius-/Elevation-Skala nach shared/theme.js verschoben
  // (Primitiv-Bibliothek-Fundament — shared-Primitive brauchen die Tokens self-
  // contained). Hier via merge (pages/ThemeProvider.jsx) weiterhin verfügbar;
  // einzelne Werte ließen sich hier bei Bedarf überschreiben.
};
